import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  isShowLogOutConfirm: boolean;
  

  constructor(public configService:ConfigService ,private router: Router) { }

  ngOnInit(): void {
  }

  LogoutModelClose(){
    // this.isShowLogOutConfirm
  }

  public confirmLogOut() {
    this.configService.logoutUser(false, true);
    this.configService.isShowLogOutConfirm = false;
  }

}
